import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './styles/main.css'
import RetreatLanding from './components/RetreatLanding'
import TermsAndConditions from './components/TermsAndConditions'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<RetreatLanding />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
